import { PageTitle } from './PageTitle';
import { Card } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { useMsal } from "@azure/msal-react";
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const style = {
    position: 'absolute',//as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const ReportNew = (props) => {

	const navigate = useNavigate();
	const {instance, accounts } = useMsal();
	const [openModal, setOpenModal] = useState(false);
	const [modalText,setModalText]=useState();
	const [idReport, setIdReport] = useState();
	const [projectName, setProjectName] = useState();
	const [clientName, setClientName] = useState();
	const [emailAddress, setEmailAddress] = useState();

	function requestAgriadaptToken() {
		// Silently acquires an access token which is then attached to a request for Agriadapt API
		const loginRequest = {
			scopes: ["api://50e457bf-ecab-45c0-8fa5-e2bf19675f5a/Agriadapt.Contributors"]
		};
		instance.acquireTokenSilent({
			...loginRequest,
			account: accounts[0]
		}).then((response) => {
			sessionStorage.setItem("agriadaptToken", response.accessToken);         
			// getReports();       
		});
	}

	const handleClose = () => {
		setIdReport(null);
		setClientName("");
		setProjectName("");
		setEmailAddress("");
		navigate('/');  
	};

	const handleOpenModal = (text) => {
		setModalText(text)
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setModalText("")
		setOpenModal(false);
	};

	const projectNameChange = event => {
		setProjectName(event.target.value);
	};

	const clientNameChange = event => {
		setClientName(event.target.value);
	};

	const emailAddressChange = event => {
		setEmailAddress(event.target.value);
	};

	const handleInputChangeFilesCrops= event =>  {
		uploadFiles(event.target.files,idReport,"Crops");
	}

	const handleInputChangeFilesFacilities= event => {
		uploadFiles(event.target.files,idReport,"Facilities");
	}

	const handleInputChangeFilesLivestock= event =>  {
		uploadFiles(event.target.files,idReport,"Livestock");
	}

	const handleInputChangeTransportation= event =>  {
		uploadFiles(event.target.files,idReport,"Transportation");
	}

	const handleInputChangeTransportationZip= event =>  {
		uploadFiles(event.target.files,idReport,"TransportationZip");
	}

	useEffect(() => {
		requestAgriadaptToken();
	}, []); 

	const saveReport= () => {  
		if(projectName && clientName && emailAddress) {
			const data = {
				projectName: projectName,
				clientName: clientName,
				emailAddress: emailAddress
			};

			if (idReport==null) {
				postReport(data);
			} else {
				data.id=idReport;
				putReport(data);
			}
		} else {
			handleOpenModal("Project Name, Client Name, and email are required")
		}
	};

	const postReport= (data) => {    
		let config = {
			method: 'post',
			url: "https://idbinvestapi-t.iadb.org/agriadapt/Report",
			headers: { 
				'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
				'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`//PROD
			},
			data:data
		};

		axios(config).then(res => {
			setIdReport(res.data.id);
			console.log(res);   
			handleOpenModal("Saved");
		});
	}

	const putReport= (data) => {
		try {  
			let config = {
				method: 'put',
				url: "https://idbinvestapi-t.iadb.org/agriadapt/Report/"+idReport,
				headers: { 
					'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
					'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`//PROD
				},
				data:data
			}; 
			axios(config).then(res => {
				console.log(res);     
				handleOpenModal("Updated");
			});
		} catch(error) {
			console.log(error);
		}
	};

	const uploadFiles= (files,idReport,fileType) => {
		let data = new FormData();
		data.append('', files[0]);
		data.append('fileType',fileType);
		data.append('reportId', idReport);

		var config = {
			method: 'post',
			url: 'https://idbinvestapi-t.iadb.org/agriadapt/Report/uploadDataFile',
			headers: { 
				'Content-Type': 'multipart/form-data', 
				'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
				'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`//PROD
			},
			data : data
		};

		axios(config)
		.then(response => {
			console.log(response);
			const date = new Date();
			console.log("Report "+ fileType + " uploaded "+ date);
		}).catch(function (error) {
			console.log(error);
		});
	}

	const submitReport = () => {  
		try { 
			let config = {
				method: 'get',
				url: `https://idbinvestapi-t.iadb.org/agriadapt/Report/submitReport?reportId=`+idReport,
				headers: { 
					'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
					'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`//PROD
				}
			};  
			axios(config)
			.then(res => {
				console.log(res);
				const date = new Date();
				console.log("Reports Submited "+ date); 
				handleOpenModal("Reports Submited");
			});
		} catch(error) {
			console.log(error);
		}
	}

	const getReportOutput =()=>{  
		let config = {
			method: 'get',
			url: `https://-t.iadb.org/agriadapt/Report/getReportOutput?reportId=`+idReport,
			headers: { 
				'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
				'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`//PROD
			}
		};   
		axios(config)
		.then(res=>{
			console.log(res);
			if(res.data.reportZipUrl) {
				handleOpenModal("Report was create url:"+res.data.reportZipUrl);
			} else {
				handleOpenModal("Report is pending to generate");
			}
		});
	}
  
    return <>
        <PageTitle title="Project"/>
        <Card className='mb-3'>
            <Card.Header>
				Project Information
            </Card.Header>
            <Card.Body>
              <div className='w-100 mx-auto mb-3'>
				<TextField
					margin="normal"
					id="projectName"
					label="Project Name"
					type="text"
					fullWidth
					required={true}
					variant="outlined"
					value={projectName}
					onChange={projectNameChange}
					/>
				<TextField
                    margin="normal"
                    id="clientName"
                    label="Client Name"
                    type="text"
                    required={true}
                    fullWidth
                    variant="outlined"
                    value={clientName}
                    onChange={clientNameChange}
                    />
                  <TextField
                    margin="normal"
                    id="emailAddress"
                    label="Email Address"
                    type="email"
                    required={true}
                    fullWidth
                    variant="outlined"
                    value={emailAddress}
                    onChange={emailAddressChange}
                    />
              </div>
            </Card.Body>
            <Card.Footer>
              <Button onClick={saveReport} variant='contained' className='mr-2'>Save</Button>
              <Button onClick={handleClose} variant='contained'>Return to Reports</Button>
            </Card.Footer>
        </Card>
        
        <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Alert
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {modalText}
                </Typography>
                <div style={{"textAlign":"right"}}><Button onClick={handleCloseModal} >Close</Button></div>
            </Box>
            
        </Modal>
		
        {idReport &&
        <Card>
            <Card.Header>
				Project Data
            </Card.Header>
            <Card.Body>
                <div className='w-100 mx-auto mb-3'>
                    <div className="row mx-auto mb-3">
                        <div className="col flex-1">
                            <label htmlFor='agricultureData' className="form-label">Agriculture Data</label>
                            <input type="file" className="form-control" accept='.xlsx' name="upload_file" onChange={handleInputChangeFilesCrops} />
                        </div>
                    </div>
                    <div className="row mx-auto mb-3">
                        <div className="col flex-1">
                            <label htmlFor='facilitiesData' className="form-label">Facilities Data</label>
                            <input type="file" className="form-control" accept='.xlsx' name="upload_file" onChange={handleInputChangeFilesFacilities} />
                        </div>
                    </div>
                    <div className="row mx-auto mb-3">
                        <div className="col flex-1">
                            <label htmlFor='livestockData' className="form-label">LiveStock Data</label>
                            <input type="file" className="form-control" accept='.xlsx' name="upload_file" onChange={handleInputChangeFilesLivestock} />
                        </div>
                    </div>
                    <div className="row mx-auto mb-3">
                        <div className="col flex-1">
                            <label htmlFor='transportationData' className="form-label">Transportation Data</label>
                            <input type="file" className="form-control" accept='.xlsx' name="upload_file" onChange={handleInputChangeTransportation} />
                        </div>
                    </div>
                    <div className="row mx-auto mb-3">
                        <div className="col flex-1">
                            <label htmlFor='transportationZipData' className="form-label">Transportation Data (ZIP FIle)</label>
                            <input type="file" className="form-control" accept='.zip' name="upload_file" onChange={handleInputChangeTransportationZip} />
                        </div>
                    </div>
                </div>
            </Card.Body>
			<Card.Footer>
				<Button variant='contained' onClick={submitReport} className='mr-2'>Submit Info</Button>
                <Button variant='contained' onClick={getReportOutput}>Get Report</Button>
			</Card.Footer>
        </Card>
        }
    </>
}